import { render, staticRenderFns } from "./leaveEmailPage.vue?vue&type=template&id=99e9e2d4&"
import script from "./leaveEmailPage.vue?vue&type=script&lang=js&"
export * from "./leaveEmailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports